<mat-toolbar class="dashboard-header">
  <img src="assets/logo.png" alt="AllUnited Logo" class="app-logo" />
  <span class="header-breadcrumb">
    <span class="header-appname">AI Planner</span>
    <span class="header-separator">/</span>
    <span class="header-pagetitle">{{ pageTitle }}</span>
  </span>
  <span class="spacer"></span>
  <a
    mat-button
    routerLink="/dashboard"
    routerLinkActive="active-link"
    [routerLinkActiveOptions]="{ exact: true }"
    >Dashboard</a
  >
  <a
    mat-button
    routerLink="/organisations"
    routerLinkActive="active-link"
    [routerLinkActiveOptions]="{ exact: true }"
    >Organisations</a
  >
  <ng-container *ngIf="selectedOrganisationId">
    <a
      mat-button
      routerLink="/resourcetypes"
      routerLinkActive="active-link"
      >Resource Types</a
    >
    <a
      mat-button
      routerLink="/resources"
      routerLinkActive="active-link"
      >Resources</a
    >
    <a
      mat-button
      routerLink="/schedules"
      routerLinkActive="active-link"
      >Schedules</a
    >
  </ng-container>
  <div class="select-container">
    <!-- SSO users see organization name as static text (non-clickable) -->
    <ng-container *ngIf="isSSOLogin">
      <span
        class="org-select-static"
        [title]="getSSOOrganisationName()"
      >
        {{ getSSOOrganisationName() }}
      </span>
    </ng-container>

    <!-- Form login users see the dropdown selector -->
    <ng-container *ngIf="!isSSOLogin">
      <ng-container *ngIf="selectedOrganisationId && getSelectedOrganisationName(); else showSelect">
        <span
          class="org-select-compact"
          tabindex="0"
          (click)="showSelectDropdown = true"
          (keydown.enter)="showSelectDropdown = true"
          [title]="getSelectedOrganisationName()"
        >
          {{ getSelectedOrganisationName() }}
          <span class="org-select-arrow">&#9662;</span>
        </span>
        <select
          *ngIf="showSelectDropdown"
          class="org-select"
          [(ngModel)]="selectedOrganisationId"
          (change)="onOrganisationChange($any($event.target).value); showSelectDropdown = false"
          (blur)="showSelectDropdown = false"
          autofocus
        >
          <option [value]="''">Choose organisation</option>
          <option
            *ngFor="let org of organisations"
            [value]="org.id">
            {{ org.name }}
          </option>
        </select>
      </ng-container>
      <ng-template #showSelect>
        <select
          class="org-select"
          [(ngModel)]="selectedOrganisationId"
          (change)="onOrganisationChange($any($event.target).value)">
          <option [value]="''">Choose organisation</option>
          <option
            *ngFor="let org of organisations"
            [value]="org.id">
            {{ org.name }}
          </option>
        </select>
      </ng-template>
    </ng-container>
  </div>
  <button 
    mat-icon-button 
    class="logout-button"
    (click)="logout()"
    matTooltip="Logout"
    aria-label="Logout">
    <mat-icon>logout</mat-icon>
  </button>
</mat-toolbar>
